import request from '@/utils/request'

const baseUrl = process.env.VUE_APP_PURCHASE_API
// const baseUrl = 'http://192.168.18.126:8081'

// 分页查询项目登记
export function fetchRegisterListApi(params) {
  return request({
    url: baseUrl + '/workbench/purchaser/page/register/entrust-projects',
    method: 'get',
    params
  })
}

// 新增登记
export function saveRegisterApi(data) {
  return request({
    url: baseUrl + '/workbench/purchaser/register/entrust-projects',
    method: 'post',
    data
  })
}

// 发布登记
export function releaseRegisterApi(data) {
  return request({
    url: baseUrl + '/workbench/purchaser/register/entrust-projects/release',
    method: 'post',
    data: data
  })
}

// 更新登记
export function updateRegisterApi(data, projectId) {
  return request({
    url:
      baseUrl + `/workbench/purchaser/register/entrust-projects/${projectId}`,
    method: 'put',
    data: data
  })
}

// 更新发布登记
export function releaseSavedRegisterApi(data, projectId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/register/entrust-projects/${projectId}/release`,
    method: 'put',
    data: data
  })
}

// 查询登记详情
export function fetchRegisterDetailApi(projectId) {
  return request({
    url:
      baseUrl + `/workbench/purchaser/register/entrust-projects/${projectId}`,
    method: 'get'
  })
}

// 切换登记项目的作废状态
export function changeRegisterVoidStatusApi(projectId, relatedStatus) {
  return request({
    url: `${baseUrl}/workbench/purchaser/register/entrust-projects/${projectId}/relatedStatus/${relatedStatus}`,
    method: 'put'
  })
}

// 委托采购单数量
export function getEntrustRegisterProjectNumApi(projectId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/register/entrust-projects/${projectId}/purchase-orders/count`,
    method: 'get'
  })
}

// 模糊查询自主登记目列表
export function getPurchaseRegisterListApi(params) {
  return request({
    url: baseUrl + `/workbench/purchaser/search/register/entrust-projects`,
    method: 'get',
    params
  })
}

// 删除登记
export function removeRegisterApi(projectId) {
  return request({
    url:
      baseUrl + `/workbench/purchaser/register/entrust-projects/${projectId}`,
    method: 'delete'
  })
}
